// ==============================
// PIXEL TRACKER – FASTR CHECKOUT (FIXED)
// ==============================

const STORE_CODE = 'atat';
const BRAND_NAME = 'ATYPICAL';
const YOUR_SERVER_URL = 'https://pixeltracker-32pl.onrender.com';

const firedEvents = {};

async function trackEvent(eventData) {
  const source = eventData.source || 'dom';
  const key = `${eventData.eventName}_${source}`;
  
  console.log('🔍 Attempting to track:', key, eventData);
  
  if (firedEvents[key]) {
    console.log('⚠️ Already fired:', key);
    return;
  }
  firedEvents[key] = true;

  const payload = {
    storeCode: STORE_CODE,
    brandName: BRAND_NAME,
    timestamp: new Date().toISOString(),
    ...eventData
  };

  console.log('✅ Tracking:', payload);

  try {
    const response = await fetch(`${YOUR_SERVER_URL}/track-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    console.log('📡 Server response:', response.status, response.statusText);
  } catch (e) {
    console.error('❌ PixelTracker error:', e);
  }
}

/* =============================== */
/* 🔥 FACEBOOK PIXEL HOOK */
/* =============================== */
(function hookFbq() {
  const originalFbq = window.fbq;
  
  window.fbq = function() {
    const args = Array.from(arguments);
    
    console.log('📊 fbq called:', args);
    
    if (args[0] === 'track' || args[0] === 'trackShopify') {
      const eventName = args[0] === 'trackShopify' ? args[2] : args[1];
      const payload = args[0] === 'trackShopify' ? args[3] : args[2] || {};

      console.log('🎯 Event detected:', eventName, 'Payload:', payload);

      if (eventName === 'InitiateCheckout') {
        console.log('🛒 InitiateCheckout detected from fbq');
        trackEvent({
          eventName: 'InitiateCheckout',
          source: 'fbq',
          value: payload.value,
          currency: payload.currency,
          contents: payload.contents || [],
          productName: payload.content_name || 'N/A',
          productImage: 'N/A'
        });
      }
      
      if (eventName === 'Purchase') {
        console.log('💰 Purchase detected from fbq');
        trackEvent({
          eventName: 'Purchase',
          source: 'fbq',
          value: payload.value,
          currency: payload.currency,
          contents: payload.contents || []
        });
      }
    }

    if (originalFbq && originalFbq.callMethod) {
      return originalFbq.callMethod.apply(originalFbq, args);
    } else if (originalFbq) {
      return originalFbq.apply(this, args);
    }
  };

  if (originalFbq) {
    window.fbq.queue = originalFbq.queue || [];
    window.fbq.loaded = originalFbq.loaded;
    window.fbq.version = originalFbq.version;
    window.fbq.push = originalFbq.push;
  }
  
  console.log('✅ Facebook Pixel hook installed');
})();

/* =============================== */
/* VIEW CONTENT */
/* =============================== */
document.addEventListener('DOMContentLoaded', () => {
  console.log('📄 Page loaded:', location.pathname);
  
  if (!location.pathname.includes('/products/')) return;

  const handle = location.pathname.split('/products/')[1]?.split('?')[0];
  if (!handle) return;

  console.log('🔎 Fetching product:', handle);

  fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(product => {
      console.log('📦 Product loaded:', product.title);
      trackEvent({
        eventName: 'ViewContent',
        productName: product.title,
        productImage: product.featured_image || product.images?.[0] || 'N/A'
      });
    })
    .catch(err => {
      console.error('❌ Failed to fetch product:', err);
    });
});

/* =============================== */
/* ADD TO CART */
/* =============================== */
document.addEventListener('click', e => {
  const btn = e.target.closest(
    'form[action*="/cart/add"] button[type="submit"], .add-to-cart-button, button[name="add"]'
  );
  if (!btn) return;

  console.log('🛍️ Add to Cart button clicked');

  const handle = location.pathname.split('/products/')[1]?.split('?')[0];
  if (!handle) return;

  fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(product => {
      console.log('📦 Product for AddToCart:', product.title);
      trackEvent({
        eventName: 'AddToCart',
        productName: product.title,
        productImage: product.featured_image || product.images?.[0] || 'N/A'
      });
    })
    .catch(err => {
      console.error('❌ Failed to fetch product for AddToCart:', err);
    });
});

/* =============================== */
/* 🚀 SHIPROCKET FASTR BUY NOW - IMMEDIATE TRACKING */
/* =============================== */
document.addEventListener('click', e => {
  const btn = e.target.closest('.sr-headless-checkout');
  
  if (!btn) return;
  
  console.log('🚀🚀🚀 SHIPROCKET BUY NOW CLICKED - TRACKING IMMEDIATELY!');
  
  // Get product handle from URL
  const handle = location.pathname.split('/products/')[1]?.split('?')[0];
  console.log('📍 Product handle:', handle);
  
  if (!handle) {
    console.warn('⚠️ Not on product page!');
    return;
  }

  // Track IMMEDIATELY - don't wait for anything
  fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(product => {
      console.log('📦 Product for InitiateCheckout:', product.title);
      console.log('🎬 FIRING INITIATE CHECKOUT NOW!');
      
      trackEvent({
        eventName: 'InitiateCheckout',
        source: 'fastr',
        productName: product.title,
        productImage: product.featured_image || product.images?.[0] || 'N/A',
        checkoutType: 'shiprocket_fastr'
      });
    })
    .catch(err => {
      console.error('❌ Failed to fetch product:', err);
      // Track anyway with minimal data
      trackEvent({
        eventName: 'InitiateCheckout',
        source: 'fastr',
        productName: 'Unknown Product',
        productImage: 'N/A',
        checkoutType: 'shiprocket_fastr'
      });
    });
}, true); // Use capture phase to fire ASAP

/* =============================== */
/* REGULAR CHECKOUT (FALLBACK) */
/* =============================== */
document.addEventListener('click', e => {
  const btn = e.target.closest(
    '[name="checkout"], .checkout-button, [href*="/checkout"]'
  );
  
  if (!btn) return;
  
  console.log('🛒 Regular checkout button clicked');

  setTimeout(() => {
    if (firedEvents['InitiateCheckout_fbq'] || firedEvents['InitiateCheckout_fastr']) {
      console.log('⏭️ Skipping - already tracked');
      return;
    }

    console.log('🔎 Fetching cart for checkout...');
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        console.log('🛒 Cart data:', cart);
        const item = cart.items?.[0];
        trackEvent({
          eventName: 'InitiateCheckout',
          source: 'dom',
          productName: item?.product_title || 'N/A',
          productImage: item?.image || 'N/A'
        });
      })
      .catch(err => {
        console.error('❌ Failed to fetch cart:', err);
      });
  }, 100);
});

console.log('🎯 PixelTracker initialized and ready!');
